// Salon catalogue: services, specialists, looks, offers, editorial content.
// One shape consumed by every page and by the appointment basket.

export const CATEGORIES = [
  { slug: "hair", photo: "look-06", label: "مو", latin: "Hair", blurb: "کوتاهی، رنگ، درمان" },
  { slug: "skin", photo: "look-09", label: "پوست", latin: "Skin", blurb: "فیشیال، پاک‌سازی، جوان‌سازی" },
  { slug: "nails", photo: "look-02", label: "ناخن", latin: "Nails", blurb: "مانیکور، پدیکور، کاشت" },
  { slug: "makeup", photo: "look-01", label: "آرایش", latin: "Makeup", blurb: "میکاپ، مژه، ابرو" },
  { slug: "bridal", photo: "hero-a", label: "عروس", latin: "Bridal", blurb: "پکیج کامل روز عروسی" },
];

const S = (s) => ({ discount: 0, tags: [], reviews: 0, includes: [], ...s });

export const SERVICES = [
  /* ---------------------------------------------------------------- hair */
  S({
    id: 1,
    slug: "cut-and-style",
    photo: "look-05",
    name: "کوتاهی و فرم‌دهی مو",
    category: "hair",
    price: 850000,
    duration: 45,
    art: "serum",
    tone: "#D8B48C",
    tone2: "#B08A5E",
    rating: 4.8,
    reviews: 214,
    tags: ["popular"],
    short: "فرم متناسب با حالت طبیعی مو و فرم صورت.",
    description:
      "پیش از هر برش، فرم صورت و حالت طبیعی موی شما بررسی می‌شود تا کوتاهی‌ای انتخاب شود که در خانه هم به‌راحتی حفظ شود. شست‌وشو، برش و حالت‌دهی در یک جلسه.",
    includes: ["مشاوره فرم صورت", "شست‌وشو و ماساژ سر", "برش تخصصی", "حالت‌دهی نهایی"],
    aftercare: "تا ۲۴ ساعت از حرارت مستقیم پرهیز کنید.",
  }),
  S({
    id: 2,
    slug: "hair-color",
    photo: "look-03",
    name: "رنگ مو تخصصی",
    category: "hair",
    price: 3200000,
    duration: 180,
    art: "flacon",
    tone: "#B5603F",
    tone2: "#8A3F27",
    rating: 4.9,
    reviews: 168,
    tags: ["popular", "signature"],
    short: "انتخاب رنگ بر اساس زیرتون پوست، با تست حساسیت.",
    description:
      "رنگ بر پایه زیرتون پوست و رنگ چشم انتخاب می‌شود. پیش از شروع، تست حساسیت گرفته می‌شود و در پایان، درمان تثبیت رنگ انجام می‌گیرد.",
    includes: ["مشاوره و انتخاب رنگ", "تست حساسیت", "رنگ‌آمیزی", "درمان تثبیت رنگ"],
    aftercare: "۴۸ ساعت مو را نشویید و از شامپوی بدون سولفات استفاده کنید.",
  }),
  S({
    id: 3,
    slug: "balayage",
    photo: "look-06",
    name: "هایلایت و بالیاژ",
    category: "hair",
    price: 4500000,
    discount: 12,
    duration: 240,
    art: "flacon",
    tone: "#E0C089",
    tone2: "#B8914F",
    rating: 4.9,
    reviews: 132,
    tags: ["signature"],
    short: "سایه‌روشن دست‌ساز با رشد طبیعی و بدون خط.",
    description:
      "بالیاژ به‌صورت دست‌آزاد اجرا می‌شود تا مرز رنگ نرم بماند و با رشد مو خط جدایی ایجاد نشود. مناسب کسانی که فاصله مراجعه‌شان طولانی است.",
    includes: ["طراحی سایه‌روشن", "اجرای دست‌آزاد", "تونر اختصاصی", "ماسک ترمیم"],
    aftercare: "هفته‌ای یک بار ماسک ترمیم‌کننده استفاده کنید.",
  }),
  S({
    id: 4,
    slug: "keratin",
    photo: "look-08",
    name: "کراتینه و صافی مو",
    category: "hair",
    price: 3800000,
    duration: 180,
    art: "tube",
    tone: "#EFE0CB",
    tone2: "#CBB393",
    rating: 4.7,
    reviews: 96,
    short: "کاهش وز و براقی ماندگار تا چهار ماه.",
    description:
      "درمان کراتینه بدون فرمالدهید که وز مو را کم می‌کند و ساختار تار مو را ترمیم می‌کند. نتیجه تا چهار ماه باقی می‌ماند.",
    includes: ["شست‌وشوی عمقی", "اعمال کراتین", "سیل حرارتی", "آبکشی و فرم‌دهی"],
    aftercare: "تا ۷۲ ساعت مو را نبندید و پشت گوش نزنید.",
  }),
  S({
    id: 5,
    slug: "hair-treatment",
    photo: "salon-03",
    name: "درمان تخصصی مو",
    category: "hair",
    price: 1200000,
    duration: 60,
    art: "jar",
    tone: "#E6DCC8",
    tone2: "#C0AA85",
    rating: 4.6,
    reviews: 121,
    short: "ترمیم عمقی برای موی رنگ‌شده و آسیب‌دیده.",
    description:
      "ماسک پروتئینی همراه با بخار و ماساژ پوست سر، برای موهایی که زیاد حرارت دیده‌اند یا رنگ شده‌اند.",
    includes: ["تشخیص نوع آسیب", "ماسک پروتئین", "بخار گرم", "ماساژ پوست سر"],
    aftercare: "بین جلسات از روغن مو استفاده کنید.",
  }),

  /* ---------------------------------------------------------------- skin */
  S({
    id: 6,
    slug: "signature-facial",
    photo: "look-09",
    name: "فیشیال تخصصی",
    category: "skin",
    price: 1600000,
    duration: 75,
    art: "serum",
    tone: "#8FC9D8",
    tone2: "#5FA6BC",
    rating: 4.9,
    reviews: 287,
    tags: ["popular", "signature"],
    short: "پروتکل اختصاصی بر اساس تشخیص پوست شما.",
    description:
      "جلسه با آنالیز پوست شروع می‌شود و پروتکل بر همان اساس چیده می‌شود؛ لایه‌برداری، ماساژ لنفاوی، ماسک و آبرسانی نهایی.",
    includes: ["آنالیز پوست", "لایه‌برداری ملایم", "ماساژ لنفاوی", "ماسک اختصاصی"],
    aftercare: "تا ۱۲ ساعت آرایش نکنید و فردا حتماً ضدآفتاب بزنید.",
  }),
  S({
    id: 7,
    slug: "hydrafacial",
    photo: "look-07",
    name: "هیدرافیشیال",
    category: "skin",
    price: 2400000,
    duration: 60,
    art: "serum",
    tone: "#A8D5E2",
    tone2: "#6BAEC4",
    rating: 4.8,
    reviews: 154,
    tags: ["popular"],
    short: "پاک‌سازی، لایه‌برداری و آبرسانی در یک مرحله.",
    description:
      "دستگاه هم‌زمان منافذ را تمیز می‌کند و سرم آبرسان تزریق می‌کند. بدون دوره نقاهت؛ بلافاصله بعد از جلسه قابل ادامه روز است.",
    includes: ["پاک‌سازی مکانیکی", "لایه‌برداری اسیدی ملایم", "تزریق سرم", "محافظت نهایی"],
    aftercare: "۲۴ ساعت از سونا و استخر پرهیز کنید.",
  }),
  S({
    id: 8,
    slug: "microneedling",
    photo: "look-04",
    name: "میکرونیدلینگ",
    category: "skin",
    price: 3600000,
    discount: 15,
    duration: 90,
    art: "serum",
    tone: "#E4A88E",
    tone2: "#C67F62",
    rating: 4.7,
    reviews: 88,
    short: "تحریک کلاژن برای بافت و جای جوش.",
    description:
      "با ایجاد کانال‌های میکروسکوپی، تولید کلاژن تحریک می‌شود. برای بهبود بافت پوست و کم‌رنگ شدن جای جوش، سه تا چهار جلسه توصیه می‌شود.",
    includes: ["بی‌حسی موضعی", "میکرونیدلینگ", "سرم رشد", "ماسک آرام‌بخش"],
    aftercare: "۴۸ ساعت آرایش نکنید؛ یک هفته ضدآفتاب جدی.",
  }),
  S({
    id: 9,
    slug: "deep-cleanse",
    photo: "salon-02",
    name: "پاک‌سازی عمیق پوست",
    category: "skin",
    price: 1400000,
    duration: 60,
    art: "jar",
    tone: "#DCE8DC",
    tone2: "#A9C4AB",
    rating: 4.6,
    reviews: 176,
    short: "تخلیه منافذ با بخار و ابزار استریل.",
    description:
      "با بخار گرم منافذ باز می‌شوند و تخلیه با ابزار استریل انجام می‌گیرد. در پایان ماسک قابض و آرام‌بخش استفاده می‌شود.",
    includes: ["بخار گرم", "تخلیه منافذ", "ماسک قابض", "آبرسانی"],
    aftercare: "تا ۲۴ ساعت آرایش سنگین نزنید.",
  }),

  /* --------------------------------------------------------------- nails */
  S({
    id: 10,
    slug: "classic-manicure",
    photo: "look-02",
    name: "مانیکور کلاسیک",
    category: "nails",
    price: 620000,
    duration: 45,
    art: "compact",
    tone: "#E8B7B0",
    tone2: "#C1837E",
    rating: 4.7,
    reviews: 231,
    short: "فرم‌دهی، مراقبت از کوتیکول و لاک.",
    description:
      "فرم‌دهی ناخن، مراقبت از کوتیکول، ماساژ دست و لاک دلخواه. ابزارها برای هر مراجعه‌کننده استریل می‌شوند.",
    includes: ["فرم‌دهی", "مراقبت کوتیکول", "ماساژ دست", "لاک"],
    aftercare: "روزانه روغن کوتیکول بزنید.",
  }),
  S({
    id: 11,
    slug: "spa-pedicure",
    photo: "look-02",
    name: "پدیکور اسپا",
    category: "nails",
    price: 890000,
    duration: 60,
    art: "jar",
    tone: "#CFE0E8",
    tone2: "#9CBCCB",
    rating: 4.8,
    reviews: 143,
    tags: ["popular"],
    short: "وان گرم، لایه‌برداری و ماساژ ساق.",
    description:
      "با وان گرم و نمک شروع می‌شود، لایه‌برداری پاشنه و ماساژ ساق ادامه پیدا می‌کند و با لاک تمام می‌شود.",
    includes: ["وان نمک", "لایه‌برداری پاشنه", "ماساژ ساق", "لاک"],
    aftercare: "شب‌ها کرم مرطوب‌کننده پا استفاده کنید.",
  }),
  S({
    id: 12,
    slug: "nail-extension",
    photo: "look-02",
    name: "کاشت ناخن",
    category: "nails",
    price: 1900000,
    duration: 120,
    art: "compact",
    tone: "#F0DDD2",
    tone2: "#C09A88",
    rating: 4.6,
    reviews: 118,
    short: "فرم و بلندی دلخواه با مواد بادوام.",
    description:
      "کاشت با ژل یا پودر، متناسب با فرم انگشت و سبک مورد نظر شما. ترمیم هر سه هفته توصیه می‌شود.",
    includes: ["آماده‌سازی بستر", "کاشت", "فرم‌دهی و سوهان", "طراحی دلخواه"],
    aftercare: "از ناخن به‌عنوان ابزار استفاده نکنید.",
  }),
  S({
    id: 13,
    slug: "gel-polish",
    photo: "look-02",
    name: "لاک ژل",
    category: "nails",
    price: 550000,
    duration: 40,
    art: "compact",
    tone: "#C75B6B",
    tone2: "#96394A",
    rating: 4.5,
    reviews: 197,
    short: "ماندگاری سه هفته بدون پریدگی.",
    description:
      "لاک ژل با خشک‌کن نوری، ماندگاری حدود سه هفته دارد و برق اولیه‌اش را حفظ می‌کند.",
    includes: ["آماده‌سازی", "بیس کت", "دو لایه رنگ", "تاپ کت"],
    aftercare: "برای برداشتن، حتماً به سالن مراجعه کنید.",
  }),

  /* -------------------------------------------------------------- makeup */
  S({
    id: 14,
    slug: "day-makeup",
    photo: "look-01",
    name: "میکاپ روز",
    category: "makeup",
    price: 1500000,
    duration: 60,
    art: "lipstick",
    tone: "#C08A8A",
    tone2: "#96595F",
    rating: 4.7,
    reviews: 165,
    short: "آرایش سبک و طبیعی برای ساعات روز.",
    description:
      "پوششی سبک با تمرکز بر یکدست‌کردن پوست و برجسته‌کردن اجزای صورت، مناسب محیط کار و مهمانی‌های روز.",
    includes: ["آماده‌سازی پوست", "پوشش سبک", "چشم و ابرو", "فیکس نهایی"],
    aftercare: "شب حتماً آرایش را با روغن پاک‌کننده بردارید.",
  }),
  S({
    id: 15,
    slug: "evening-makeup",
    photo: "hero-main",
    name: "میکاپ شب و مجلسی",
    category: "makeup",
    price: 2800000,
    duration: 90,
    art: "lipstick",
    tone: "#8E2F3C",
    tone2: "#5E1F29",
    rating: 4.9,
    reviews: 208,
    tags: ["popular"],
    short: "پوشش کامل با ماندگاری تا پایان مراسم.",
    description:
      "آرایش کامل با پوشش بالا و فیکس حرفه‌ای که زیر نور مجلس و در عکس درست بنشیند و تا پایان شب بماند.",
    includes: ["آماده‌سازی پوست", "پوشش کامل", "طراحی چشم", "مژه مصنوعی", "فیکس"],
    aftercare: "مژه مصنوعی را با حلال مخصوص جدا کنید.",
  }),
  S({
    id: 16,
    slug: "lash-extension",
    photo: "hero-b",
    name: "اکستنشن مژه",
    category: "makeup",
    price: 1600000,
    duration: 90,
    art: "tube",
    tone: "#33302D",
    tone2: "#15130F",
    rating: 4.8,
    reviews: 176,
    tags: ["popular"],
    short: "تار به تار، متناسب با فرم چشم.",
    description:
      "مژه‌ها تار به تار روی مژه طبیعی نصب می‌شوند. تراکم و طول بر اساس فرم چشم و ضخامت مژه طبیعی انتخاب می‌شود.",
    includes: ["مشاوره فرم چشم", "نصب تار به تار", "براشینگ", "ترمیم رایگان هفته اول"],
    aftercare: "۲۴ ساعت اول مژه‌ها را خیس نکنید.",
  }),
  S({
    id: 17,
    slug: "brow-design",
    photo: "look-04",
    name: "طراحی و فرم ابرو",
    category: "makeup",
    price: 480000,
    duration: 30,
    art: "compact",
    tone: "#9A6F51",
    tone2: "#6B4930",
    rating: 4.6,
    reviews: 254,
    short: "فرم بر اساس تناسب صورت، نه مد روز.",
    description:
      "فرم ابرو بر اساس فاصله چشم‌ها و تناسب صورت طراحی می‌شود. اصلاح با موچین و بند، و در صورت نیاز رنگ یا هاشور.",
    includes: ["طراحی فرم", "اصلاح", "رنگ یا هاشور", "آرام‌بخش پوست"],
    aftercare: "تا ۱۲ ساعت محصول رنگی روی ابرو نزنید.",
  }),

  /* -------------------------------------------------------------- bridal */
  S({
    id: 18,
    slug: "bridal-package",
    photo: "hero-a",
    name: "پکیج کامل عروس",
    category: "bridal",
    price: 12000000,
    duration: 300,
    art: "flacon",
    tone: "#EFE3D2",
    tone2: "#CBB08A",
    rating: 5,
    reviews: 92,
    tags: ["signature"],
    short: "از تست گریم تا لحظه خروج، یک تیم اختصاصی.",
    description:
      "یک تیم کامل در اختیار شماست: گریم، شینیون، ناخن و مراقبت پوست پیش از مراسم. جلسه تست پیش از روز عروسی جداگانه برگزار می‌شود.",
    includes: ["جلسه تست گریم", "گریم روز عروسی", "شینیون", "مانیکور", "همراهی تا خروج"],
    aftercare: "شب قبل خوب بخوابید و آب زیاد بنوشید.",
  }),
  S({
    id: 19,
    slug: "engagement-makeup",
    photo: "look-01",
    name: "گریم نامزدی",
    category: "bridal",
    price: 5500000,
    discount: 10,
    duration: 150,
    art: "flacon",
    tone: "#F1DEDA",
    tone2: "#C9A0A0",
    rating: 4.9,
    reviews: 74,
    short: "گریم و مو برای مراسم عقد و نامزدی.",
    description:
      "گریم کامل به‌همراه فرم‌دهی مو، طراحی‌شده برای دوام طولانی و ظاهر درست در عکاسی.",
    includes: ["گریم کامل", "فرم‌دهی مو", "مژه", "فیکس بلندمدت"],
    aftercare: "برای عکاسی، فیکس را همراه داشته باشید.",
  }),
  S({
    id: 20,
    slug: "bridal-trial",
    photo: "look-08",
    name: "تست گریم عروس",
    category: "bridal",
    price: 2200000,
    duration: 90,
    art: "compact",
    tone: "#E0C4B4",
    tone2: "#B08E7C",
    rating: 4.8,
    reviews: 61,
    short: "پیش از روز اصلی، همه‌چیز را نهایی کنید.",
    description:
      "در این جلسه سبک گریم، رنگ‌ها و مدل مو نهایی می‌شود تا روز مراسم هیچ تصمیمی باقی نماند.",
    includes: ["مشاوره سبک", "اجرای گریم آزمایشی", "عکس مرجع", "ثبت فرمول رنگ"],
    aftercare: "عکس‌های تست را برای روز مراسم نگه دارید.",
  }),
];

/* ------------------------------------------------------------ specialists */

export const STAFF = [
  {
    id: 1, slug: "neda-rostami", photo: "team-01", name: "ندا رستمی",
    role: "متخصص رنگ و بالیاژ", latin: "Color Director",
    experience: 12, rating: 4.9, reviews: 186,
    tone: "#B5603F", tone2: "#8A3F27",
    categories: ["hair"],
    bio: "دوازده سال است که فقط روی رنگ کار می‌کند. تخصصش اصلاح رنگ‌های ناموفق و بالیاژهای نرم است.",
  },
  {
    id: 2, slug: "sara-ahmadi", photo: "team-02", name: "سارا احمدی",
    role: "متخصص پوست", latin: "Skin Therapist",
    experience: 9, rating: 4.9, reviews: 243,
    tone: "#8FC9D8", tone2: "#5FA6BC",
    categories: ["skin"],
    bio: "پروتکل‌هایش را بر اساس آنالیز پوست می‌چیند، نه بسته‌های آماده. روی پوست‌های حساس و آکنه‌دار تمرکز دارد.",
  },
  {
    id: 3, slug: "maryam-kazemi", photo: "team-03", name: "مریم کاظمی",
    role: "آرایشگر عروس", latin: "Bridal Artist",
    experience: 15, rating: 5, reviews: 128,
    tone: "#CBB08A", tone2: "#9C8154",
    categories: ["bridal", "makeup"],
    bio: "پانزده سال و بیش از هشتصد عروس. سبکش طبیعی و ماندگار است؛ چیزی که در عکس هم درست می‌نشیند.",
  },
  {
    id: 4, slug: "elham-nouri", photo: "team-04", name: "الهام نوری",
    role: "متخصص ناخن", latin: "Nail Artist",
    experience: 7, rating: 4.8, reviews: 197,
    tone: "#C75B6B", tone2: "#96394A",
    categories: ["nails"],
    bio: "دقتش روی فرم و کوتیکول کار را متفاوت می‌کند. طراحی‌های مینیمال تخصص اوست.",
  },
  {
    id: 5, slug: "parisa-moradi", photo: "team-05", name: "پریسا مرادی",
    role: "متخصص مژه و ابرو", latin: "Lash & Brow",
    experience: 6, rating: 4.8, reviews: 164,
    tone: "#33302D", tone2: "#15130F",
    categories: ["makeup"],
    bio: "فرم ابرو را با تناسب صورت می‌سنجد، نه با مد فصل. اکستنشن‌هایش سبک و طبیعی است.",
  },
  {
    id: 6, slug: "shiva-tehrani", photo: "team-06", name: "شیوا تهرانی",
    role: "استایلیست مو", latin: "Hair Stylist",
    experience: 10, rating: 4.7, reviews: 152,
    tone: "#D8B48C", tone2: "#A87F52",
    categories: ["hair"],
    bio: "برش‌هایش طوری است که بدون سشوار هم فرم دارد. روی موهای فر و حجیم تجربه زیادی دارد.",
  },
];

/* ---------------------------------------------------------------- looks */

export const LOOKS = [
  { id: 1, photo: "look-06", title: "بالیاژ عسلی", serviceSlug: "balayage", staffId: 1, tone: "#E0C089", tone2: "#A87A38", span: "tall" },
  { id: 2, photo: "hero-a", title: "شینیون عروس", serviceSlug: "bridal-package", staffId: 3, tone: "#EFE3D2", tone2: "#C0A176", span: "wide" },
  { id: 3, photo: "hero-main", title: "میکاپ دودی", serviceSlug: "evening-makeup", staffId: 3, tone: "#6E5A63", tone2: "#3B2F36" },
  { id: 4, photo: "look-02", title: "ناخن مینیمال", serviceSlug: "gel-polish", staffId: 4, tone: "#E8C4C0", tone2: "#B57F7F" },
  { id: 5, photo: "look-03", title: "رنگ مسی", serviceSlug: "hair-color", staffId: 1, tone: "#C1663C", tone2: "#8A3F1F", span: "tall" },
  { id: 6, photo: "look-09", title: "پوست شیشه‌ای", serviceSlug: "hydrafacial", staffId: 2, tone: "#B8DCE6", tone2: "#77AEC0" },
  { id: 7, photo: "hero-b", title: "اکستنشن طبیعی", serviceSlug: "lash-extension", staffId: 5, tone: "#4A443F", tone2: "#1E1B18", span: "wide" },
  { id: 8, photo: "look-04", title: "فرم ابروی بلند", serviceSlug: "brow-design", staffId: 5, tone: "#A67B57", tone2: "#6E4A2E" },
  { id: 9, photo: "look-05", title: "کوتاهی لایه‌ای", serviceSlug: "cut-and-style", staffId: 6, tone: "#D2B490", tone2: "#9C7A50" },
];

/* --------------------------------------------------------------- offers */

export const OFFERS = [
  {
    id: 1, photo: "look-01", title: "اولین مراجعه", latin: "First Visit",
    value: 20, kind: "percent",
    body: "بیست درصد تخفیف روی اولین خدمتی که در رُز رزرو می‌کنید.",
    until: "پایان همین ماه", tone: "#E6D2C3", tone2: "#BE9C7A",
  },
  {
    id: 2, photo: "salon-02", title: "پکیج مو و پوست", latin: "Duo Package",
    value: 850000, kind: "amount",
    body: "با رزرو هم‌زمان یک خدمت مو و یک خدمت پوست، از تخفیف پکیج استفاده کنید.",
    until: "ظرفیت محدود", tone: "#B8DCE6", tone2: "#7BA8B8",
  },
  {
    id: 3, photo: "salon-01", title: "صبح‌های آرام", latin: "Quiet Mornings",
    value: 15, kind: "percent",
    body: "شنبه تا دوشنبه، نوبت‌های پیش از ساعت ۱۲ با پانزده درصد تخفیف.",
    until: "همیشگی", tone: "#DCE8DC", tone2: "#9FBBA2",
  },
  {
    id: 4, photo: "hero-a", title: "عروس زمستان", latin: "Winter Bridal",
    value: 1800000, kind: "amount",
    body: "پکیج کامل عروس برای مراسم‌های دی تا اسفند، با تخفیف فصلی.",
    until: "تا پایان اسفند", tone: "#EFDCE0", tone2: "#C295A0",
  },
];

/* ------------------------------------------------------------ editorial */

export const VISIT_STEPS = [
  {
    step: 1, title: "مشاوره", latin: "Consult",
    body: "پیش از هر کاری می‌نشینیم و حرف می‌زنیم؛ از حالت طبیعی مو و پوست تا کاری که واقعاً برای روتین روزمره‌ات جواب می‌دهد.",
    serviceSlug: "signature-facial",
    photo: "salon-02",
  },
  {
    step: 2, title: "آماده‌سازی", latin: "Prepare",
    body: "پوست یا مو برای خدمت آماده می‌شود. این مرحله همان چیزی است که تفاوت نتیجه ماندگار با نتیجه یک‌روزه را می‌سازد.",
    serviceSlug: "deep-cleanse",
    photo: "look-09",
  },
  {
    step: 3, title: "اجرا", latin: "Craft",
    body: "کار را متخصصِ همان حوزه انجام می‌دهد، نه هرکسی که آزاد است. ابزارها برای هر مراجعه استریل می‌شوند.",
    serviceSlug: "balayage",
    photo: "salon-03",
  },
  {
    step: 4, title: "مراقبت", latin: "Aftercare",
    body: "پیش از رفتن، دقیقاً می‌دانی در خانه چه کنی تا نتیجه بماند. پیگیری هفته اول با ما است.",
    serviceSlug: "hair-treatment",
    photo: "look-05",
  },
];

export const TESTIMONIALS = [
  {
    id: 1, name: "نگار م.", city: "تهران", rating: 5,
    body: "برای بالیاژ رفتم و اولین باری بود که رنگ دقیقاً همان چیزی شد که در ذهنم بود. سه ماه گذشته و هنوز خط رشد ندارد.",
    service: "هایلایت و بالیاژ",
  },
  {
    id: 2, name: "سارا ک.", city: "شیراز", rating: 5,
    body: "گریم عروسی خواهرم را اینجا انجام دادیم. تا آخر شب دست‌نخورده ماند و در عکس‌ها هم طبیعی افتاد، نه ماسکی.",
    service: "پکیج کامل عروس",
  },
  {
    id: 3, name: "مهسا ر.", city: "اصفهان", rating: 4,
    body: "پوستم حساس است و همیشه بعد از فیشیال قرمز می‌شد. اینجا اول آنالیز کردند و پروتکل را عوض کردند. تفاوتش واقعاً محسوس بود.",
    service: "فیشیال تخصصی",
  },
  {
    id: 4, name: "الهام ص.", city: "تبریز", rating: 5,
    body: "اکستنشن مژه‌ام سه هفته کامل ماند و هیچ کدام نریخت. فرم چشمم را هم قبلش پرسیدند که برایم تازگی داشت.",
    service: "اکستنشن مژه",
  },
];

export const ARTICLES = [
  {
    slug: "before-color",
    photo: "look-03",
    title: "قبل از رنگ کردن مو چه بدانیم؟",
    latin: "Journal 01",
    excerpt: "بیشتر رنگ‌های ناموفق از انتخاب اشتباه زیرتون می‌آید، نه از کیفیت رنگ.",
    read: 6, tone: "#B5603F",
  },
  {
    slug: "facial-frequency",
    photo: "look-09",
    title: "هر چند وقت یک‌بار فیشیال؟",
    latin: "Journal 02",
    excerpt: "پاسخ به نوع پوست بستگی دارد؛ اما یک قاعده کلی هست که تقریباً همیشه کار می‌کند.",
    read: 4, tone: "#8FC9D8",
  },
  {
    slug: "bridal-timeline",
    photo: "hero-a",
    title: "تقویم زیبایی عروس",
    latin: "Journal 03",
    excerpt: "از شش ماه مانده تا صبح مراسم؛ چه کاری را کِی انجام دهیم.",
    read: 7, tone: "#CBB08A",
  },
];

export const ANNOUNCEMENTS = [
  "رزرو آنلاین نوبت، بدون تماس تلفنی",
  "بیست درصد تخفیف برای اولین مراجعه",
  "ابزار استریل و اختصاصی برای هر مراجعه‌کننده",
];

export const SALON = {
  name: "رُز",
  latin: "ROZ",
  tagline: "سالن زیبایی",
  address: "تهران، خیابان ولیعصر، بالاتر از پارک‌وی، پلاک ۱۲۴۰",
  phone: "۰۲۱–۲۲۳۴۵۶۷۸",
  mobile: "۰۹۱۲–۱۲۳۴۵۶۷",
  hours: [
    { d: "شنبه تا چهارشنبه", h: "۹:۰۰ تا ۲۱:۰۰" },
    { d: "پنجشنبه", h: "۹:۰۰ تا ۱۸:۰۰" },
    { d: "جمعه", h: "تعطیل" },
  ],
};

/* ------------------------------------------------------------ selectors */

/** Resolve a photo key to its public URL. */
export const img = (key) => `${process.env.PUBLIC_URL || ""}/images/${key}.jpg`;

export const bySlug = (slug) => SERVICES.find((s) => s.slug === slug);
export const byCategory = (c) => SERVICES.filter((s) => s.category === c);
export const byTag = (t) => SERVICES.filter((s) => s.tags.includes(t));
export const staffById = (id) => STAFF.find((s) => s.id === id);
export const staffFor = (categorySlug) =>
  STAFF.filter((s) => s.categories.includes(categorySlug));

export const categoryLabel = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.label ?? slug;

/** Latin name — the `.eyebrow` style is LTR/uppercase and mangles Persian. */
export const categoryLatin = (slug) =>
  CATEGORIES.find((c) => c.slug === slug)?.latin ?? slug;

export const relatedServices = (service, n = 3) =>
  SERVICES.filter((s) => s.id !== service.id && s.category === service.category).slice(0, n);
